import 'vue';
import './useFlatOptions';
import { VALUE_SPLIT, getAllChildPath } from '../utils/commonUtil';
export default (existInChecked, // 勾选状态
pathKey, checkedPathKeys, triggerOption, mergedflatoptions) => {
    let nextRawCheckedKeys = checkedPathKeys;
    if (triggerOption.children?.length) {
        const allChildPath = getAllChildPath(triggerOption.children, pathKey);
        const filter = (item, other = true) => {
            return (allChildPath.filter(child => {
                const itemValue = item.path.split(VALUE_SPLIT);
                const childValue = child.split(VALUE_SPLIT);
                return (item.path !== child &&
                    itemValue[itemValue.length - 1] === childValue[childValue.length - 1]);
            }).length && other);
        };
        if (!existInChecked) {
            // 勾选
            const exclude = mergedflatoptions.value
                .filter(item => filter(item, !checkedPathKeys.includes(item.path)))
                .map(item => item.path);
            nextRawCheckedKeys = [...checkedPathKeys, ...exclude, pathKey];
        }
        else {
            const exclude = mergedflatoptions.value.filter(item => filter(item)).map(item => item.path);
            nextRawCheckedKeys = checkedPathKeys.filter(key => key !== pathKey && !exclude.includes(key));
        }
    }
    else {
        const filter = (item, path, other = true) => {
            const itemValue = item.path.split(VALUE_SPLIT);
            const pathValue = path.split(VALUE_SPLIT);
            return (itemValue[itemValue.length - 1] === pathValue[pathValue.length - 1] &&
                item.path !== path &&
                other);
        };
        if (!existInChecked) {
            const add = mergedflatoptions.value
                .filter(item => filter(item, pathKey, !checkedPathKeys.includes(item.path)))
                .map(item => item.path);
            nextRawCheckedKeys = [...checkedPathKeys, pathKey, ...add];
        }
        else {
            const add = mergedflatoptions.value
                .filter(item => filter(item, pathKey))
                .map(item => item.path);
            nextRawCheckedKeys = checkedPathKeys.filter(key => key !== pathKey && !add.includes(key));
        }
    }
    return nextRawCheckedKeys;
};
